<template>
  <div>
    <canvas 
      ref="canvas"
      :width="config.width"
      :height="config.height > 980 ? 980 : config.height"
      style="border:0 solid black;background-size: cover;"
      :style="{ backgroundImage: `url(${urlBackground})` }" 
      :locale="locale"
    />
    <legend-map
      :top="top"
      :config="config"
      :locale="locale"
    />
    <categories
      :top="top"
      :config="config"
      :locale="locale"
      :selectedCategoryID="selectedCategoryID"
      :onSelectCategory="handleSelectCategory"
    />
    <map-info :value="selectedPoint" :onClose="() => {selectedPoint = null}" :locale="locale" />
  </div>
</template>
<script>
import { Canvas, Rect, Circle, Text, Group, FabricImage } from 'fabric'
import MapInfo from './MapInfo'
import LegendMap from './LegendMap'
import Categories from './Categories'
export default {
  components: {
    MapInfo,
    LegendMap,
    Categories,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    top: 0,
    main: null,
    image: null,
    background: null,
    urlBackground: null,
    selectedPoint: null,
    selectedCategoryID: null,
  }),
  mounted () {
      this.top = this.$refs.canvas.getBoundingClientRect().top + window.scrollY + 20
      this.main = new Canvas(this.$refs.canvas)
      this.background = new Image()
      this.background.onload = () => {
        this.main.renderAll()
      }
      this.main.remove(...this.main.getObjects())
      this.main.on('object:modified', this.handleChange)
      if (this.config.background) {
        this.background.src = this.config.background
        this.urlBackground = this.config.background
      }
    this.preparePoints()
  },
  methods: {
    async prepareImage (v) {
      return await FabricImage.fromURL(v)
    },
    async preparePoints () {
      this.main.remove(...this.main.getObjects())
      if (!this.config.points) return
      for (const item of this.config.points.filter(x => !this.selectedCategoryID || x.CategoryID  === this.selectedCategoryID)) {
        const w = item.W ? item.W : 30
        const h = item.H ? item.H : 30

        var c = new Circle({
          left: 0,
          top: 0,
          fill: item.BGColor ? item.BGColor : '#5afffa',
          stroke: '#666',
          selectable: true,
          centeredScaling:true,
          padding:2,
          hasRotatingPoint: false,
          borderColor: 'black',
          cornerColor: 'black',
          radius: (w / 2),
        })

        var t = new Text(item.Pos.toString(), {
          fontFamily: 'Calibri',
          fontSize: h*0.6,
          fill: item.Color ? item.Color : '#000000',
          textAlign: 'center',
          originX: 'center',
          originY: 'center',
          left: 0.5*w, top: 0.5*h,
        })
        const group = [c, t]
        if (item.Icon) {
          var i = await this.prepareImage(item.Icon)
          console.log(i)
          if (i) {
          i.set({
            scaleX: 30/100,
            scaleY: 30/100,
          })
          group.push(i)
          }
        }

        var g = new Group(group, {
          top: item.Y * this.config.scale,
          left: item.X * this.config.scale,
          scaleX: (this.config.scale > 2 ? 2 : this.config.scale) + (item.Scale ? item.Scale : 0),
          scaleY: (this.config.scale > 2 ? 2 : this.config.scale) + (item.Scale ? item.Scale : 0),
          subTargetCheck: true,
        })
        g.set('selectable', false)

        g.on('mouseup', () => { 
          this.handleClick(item)
        })

        this.main.add(g)
        /*
        g.setControlsVisibility({
          bl: false,
          tl: false,
          tr: false,
          br: false,
          mt: false, // middle top disable
          mb: false, // midle bottom
          ml: false, // middle left
          mr: false, // I think you get it
          mtr: false,// rotate
        })*/
/*
        var g = new Group([c],{
            // any group attributes here
          top: item.Y * this.scale,
          left: item.X * this.scale,
          scaleX: this.scale,
          scaleY: this.scale,
        })
        
        .setControlsVisibility({
          bl: false,
          tl: false,
          tr: false,
          br: false,
          mt: false, // middle top disable
          mb: false, // midle bottom
          ml: false, // middle left
          mr: false, // I think you get it
          mtr: false,// rotate
        })*/ 
        
      }
    },
    handleClick (v) {
      this.selectedPoint = JSON.parse(JSON.stringify(v))
    },
    handleSelectCategory (v) {
      this.selectedCategoryID = v
      this.preparePoints()
    },
  },
}
</script>

